import * as yup from 'yup'

export const FormValidations = yup.object().shape({
    id: yup.string().required('Campo Obrigatório'),
    cpf: yup.string().required('Campo Obrigatório'),
    email: yup.string().email('E-mail inválido').required('Campo Obrigatório')
})